export default Object.freeze({
  en: 'en',
  jaJP: 'ja-JP',
  koKR: 'ko-KR',
  zhCN: 'zh-CN',
  zhHK: 'zh-HK',
  zhTW: 'zh-TW',
});
